import { useContext } from "react";
import { PreviewContext } from "components/Preview/contexts";

export function usePreview() {
    return useContext(PreviewContext);
}
